import { render, staticRenderFns } from "./MyRegistrations.vue?vue&type=template&id=4f2a9a8c&scoped=true"
import script from "./MyRegistrations.vue?vue&type=script&lang=js"
export * from "./MyRegistrations.vue?vue&type=script&lang=js"
import style0 from "./MyRegistrations.vue?vue&type=style&index=0&id=4f2a9a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a9a8c",
  null
  
)

export default component.exports